import LetrusLoader from '../LetrusLoader';
import './styles.scss';

function PageLoading() {
  return (
    <div data-testid="loading" className="loading">
      <LetrusLoader />
    </div>
  );
}
export default PageLoading;
